import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import PressRelease from 'modules/PressRelease';

import squareboardLogo from 'assets/images/squareboard_logo.svg';

import squareboardDrawingMan from 'assets/images/header_image.svg';

class HeaderView extends Component {
  static propTypes = {};

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidUpdate() {
    if (this.props.location.state && this.props.location.state.scrollTo) {
      const element = document.getElementById(this.props.location.state.scrollTo);
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  render() {
    return (
      <div id="header" className={`header${this.props.location.pathname === '/contact' ? ' mini' : ''}`}>
        <div className="header-navigation">
          <div
            className="u-flex"
            onClick={() => {
              this.props.history.push('/');
            }}
            role="presentation"
          >
            <img src={squareboardLogo} alt="" />
          </div>
          <div className="u-flex header-navigation-right">
            <div
              className="nav-button"
              onClick={() => {
                const carousel = document.getElementById('carousel');
                if (!carousel) {
                  this.props.history.push('/', { scrollTo: 'carousel' });
                } else {
                  carousel.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
              }}
              role="presentation"
            >
              {this.props.translations['menu.features']}
            </div>

            <PressRelease />
            {/* <NavLink to="/contact" className="nav-button">
              {this.props.translations['menu.contact']}
            </NavLink> */}
          </div>
        </div>
        {this.props.location.pathname !== '/contact' && (
          <div className="container--no-bottom-top u-max-size squareboard-workplace u-flex">
            <div id="reference-catchphrase" className="squareboard-workplace-catchphrase">
              {this.props.translations['header.digitalWorkplace']}
            </div>
            <div className="u-max-size u-pos-rel">
              <img src={squareboardDrawingMan} alt="" style={{}} />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default HeaderView;
